import * as types from '@/store/mutation-types'
import { init } from '@/api/client-api'

export const toast = ({ commit }, toast) => {
  commit(types.ADD_TOAST, toast)
  setTimeout(() => {
    commit(types.DEL_TOAST, toast)
  }, toast.type === 'error' ? 10000 : 2000)
}

const prepareToast = (toast) => {
  if (typeof toast === 'string') {
    return {
      message: toast,
      id: Math.floor(Math.random() * 1000)
    }
  }
  toast.id = Math.floor(Math.random() * 1000)
  return toast
}

export const success = ({ dispatch }, toast) => {
  let preparedToast = prepareToast(toast)
  preparedToast.type = 'success'
  dispatch('toast', preparedToast)
}

export const error = ({ dispatch }, toast) => {
  let preparedToast = prepareToast(toast)
  preparedToast.type = 'error'
  dispatch('toast', preparedToast)
}

export const doInit = ({ commit }) => {
  init().then(r => commit('SET_CAPTCHA_KEY', r.RECAPTCHA_PUBLIC_KEY))
}
